export interface VedicDimension {
  id: string;
  label: string;
  icon: string;
}

/** Trade / home-service categories for Seva Gigs marketplace. */
export const VEDIC_DIMENSIONS: VedicDimension[] = [
  { id: 'electrician',  label: 'Electrician',       icon: '⚡' },
  { id: 'plumber',      label: 'Plumber',            icon: '🔧' },
  { id: 'ac_mechanic',  label: 'AC Mechanic',        icon: '❄️' },
  { id: 'ro_mechanic',  label: 'RO Machine',         icon: '💧' },
  { id: 'carpenter',    label: 'Carpenter',          icon: '🪚' },
  { id: 'painter',      label: 'Painter',            icon: '🎨' },
  { id: 'mason',        label: 'Mason / Tiler',      icon: '🧱' },
  { id: 'appliance',    label: 'Appliance Repair',   icon: '📺' },
  { id: 'solar',        label: 'Solar / UPS',        icon: '☀️' },
  { id: 'network',      label: 'Network / CCTV',     icon: '🌐' },
  { id: 'pest_control', label: 'Pest Control',       icon: '🪲' },
  { id: 'cleaning',     label: 'Cleaning',           icon: '🧹' },
  { id: 'driver',       label: 'Driver',             icon: '🚗' },
  { id: 'home_tutor',   label: 'Home Tutor',         icon: '📚' },
  { id: 'gardener',     label: 'Gardener',           icon: '🌱' },
  { id: 'security',     label: 'Security',           icon: '🛡️' },
  { id: 'tailoring',    label: 'Tailoring',          icon: '🧵' },
  { id: 'event_setup',  label: 'Event Setup',        icon: '🎊' },
];

